import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

const SettingsCtx = createContext(null);

const DEFAULTS = {
  slogan: 'Gifts siempre contigo',
  whatsapp_number: '+50237835330',
  logo_url: '',
  hero_subtitle: 'Entrega inmediata en Guatemala 🇬🇹',
  primary_color: '#EC4899',
  accent_color: '#D8B4E2',
  low_stock_threshold: 5,
};

// Adjust HSL lightness by a delta (negative = darker, positive = lighter)
const shadeHex = (hex, delta) => {
  if (!hex || !hex.startsWith('#')) return hex;
  const h = hex.replace('#', '');
  const n = h.length === 3 ? h.split('').map((c) => c + c).join('') : h;
  let r = parseInt(n.slice(0, 2), 16);
  let g = parseInt(n.slice(2, 4), 16);
  let b = parseInt(n.slice(4, 6), 16);
  r = Math.max(0, Math.min(255, r + delta));
  g = Math.max(0, Math.min(255, g + delta));
  b = Math.max(0, Math.min(255, b + delta));
  return '#' + [r, g, b].map((v) => v.toString(16).padStart(2, '0')).join('');
};

const applyTheme = (primary, accent) => {
  const root = document.documentElement;
  if (primary) {
    root.style.setProperty('--gifts-primary', primary);
    root.style.setProperty('--gifts-primary-hover', shadeHex(primary, -25));
    root.style.setProperty('--gifts-primary-light', shadeHex(primary, 50));
  }
  if (accent) {
    root.style.setProperty('--gifts-accent', accent);
  }
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/settings');
      setSettings((prev) => {
        const merged = { ...prev, ...data };
        applyTheme(merged.primary_color, merged.accent_color);
        return merged;
      });
    } catch (_err) {
      // Settings fetch failed silently — defaults remain active
    }
    // applyTheme is a module-level pure function (stable reference); api is an imported singleton
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsCtx.Provider value={{ settings, refresh, setSettings }}>
      {children}
    </SettingsCtx.Provider>
  );
};

export const useSettings = () => useContext(SettingsCtx);
